import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'
import type SessionService from 'teacher-ui-client/services/session'

export default class TeacherGuidesRoute extends Route {
  @service contentfulClient!: ContentfulClientService

  @service session!: SessionService

  async model() {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute

    const isSubco = this.session.currentTeacher.subcoFor(subscriptionType)
    const role = isSubco ? 'subco' : 'teacher'

    const teacherGuides = await this.contentfulClient.getTeacherGuides({ subscriptionType, role })
    return {
      /**
       * - entries are already filtered by subscription type.
       * - matching null retains entries where product is undefined.
       * - Fast Phonics is not included as there is a dedicated page for FP.
       */
      teacherGuides: teacherGuides.filter((entry) =>
        ['reading_eggs', 'reading_eggspress', 'mathseeds', null].includes(entry.fields.product ?? null),
      ),
    }
  }
}
